import { render, staticRenderFns } from "./PageTrail.vue?vue&type=template&id=11c95b33"
import script from "./PageTrail.vue?vue&type=script&lang=js"
export * from "./PageTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports